import { UtilService } from "./../helpers/util-service";
import { LoggingService } from "./../helpers/logging-service";
import { RepoModel } from "../model/repo-model";
import Joi from "joi";
import { coreSchemaDefinition } from "../core/base-schema";
import { FuseErrorUtils, FuseGenericError } from "../helpers/errors";
import { getJoiValidationErrors } from "../helpers/base-joi-helper";
import { MongoFilterQueryOperation } from "./mongo-filter-query-operation";
import { MongoManageTable } from "./mongo-table-manager";
export class MongoDataOperation extends RepoModel {
    constructor({ schemaDef, mongoDb, secondaryIndexOptions, featureEntityValue, baseTableName, strictRequiredFields, dataKeyGenerator, }) {
        super();
        Object.defineProperty(this, "_fuse_partitionKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "id"
        });
        Object.defineProperty(this, "_fuse_sortKeyFieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "featureEntity"
        });
        Object.defineProperty(this, "_fuse_operationNotSuccessful", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Operation Not Successful"
        });
        Object.defineProperty(this, "_fuse_entityResultFieldKeysMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_mongoDb", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_dataKeyGenerator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_tableFullName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_strictRequiredFields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_featureEntityValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_secondaryIndexOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_errorHelper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fuse_filterQueryOperation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new MongoFilterQueryOperation()
        });
        Object.defineProperty(this, "_fuse_tableManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._fuse_mongoDb = mongoDb;
        this._fuse_dataKeyGenerator = dataKeyGenerator;
        this._fuse_tableFullName = baseTableName;
        this._fuse_featureEntityValue = featureEntityValue;
        this._fuse_secondaryIndexOptions = secondaryIndexOptions;
        this._fuse_strictRequiredFields = strictRequiredFields;
        this._fuse_errorHelper = new FuseErrorUtils();
        this._fuse_entityResultFieldKeysMap = new Map();
        const fullSchemaMapDef = {
            ...schemaDef,
            ...coreSchemaDefinition,
        };
        Object.keys(fullSchemaMapDef).forEach((key) => {
            this._fuse_entityResultFieldKeysMap.set(key, key);
        });
        this._fuse_schema = Joi.object().keys({
            ...fullSchemaMapDef,
            _id: Joi.string().required().min(5).max(512),
        });
    }
    fuse_tableManager() {
        if (!this._fuse_tableManager) {
            this._fuse_tableManager = new MongoManageTable({
                mongoDb: () => this._fuse_mongoDb(),
                secondaryIndexOptions: this._fuse_secondaryIndexOptions,
                tableFullName: this._fuse_tableFullName,
                partitionKeyFieldName: this._fuse_partitionKeyFieldName,
                sortKeyFieldName: this._fuse_sortKeyFieldName,
            });
        }
        return this._fuse_tableManager;
    }
    _fuse_generateDynamoTableKey() {
        return this._fuse_dataKeyGenerator();
    }
    async _fuse_getDbInstance() {
        return await this._fuse_mongoDb().getDbInstance();
    }
    _fuse_getLocalVariables() {
        return {
            partitionKeyFieldName: this._fuse_partitionKeyFieldName,
            sortKeyFieldName: this._fuse_sortKeyFieldName,
            featureEntityValue: this._fuse_featureEntityValue,
            secondaryIndexOptions: this._fuse_secondaryIndexOptions,
            strictRequiredFields: this._fuse_strictRequiredFields,
        };
    }
    _fuse_getNativeMongoId(dataId) {
        const { featureEntityValue } = this._fuse_getLocalVariables();
        return [featureEntityValue, dataId].join(":");
    }
    _fuse_getBaseObject({ dataId }) {
        const { partitionKeyFieldName, sortKeyFieldName, featureEntityValue } = this._fuse_getLocalVariables();
        const dataMust = {
            [partitionKeyFieldName]: dataId,
            [sortKeyFieldName]: featureEntityValue,
        };
        return dataMust;
    }
    _fuse_withConditionPassed({ item, withCondition, }) {
        if (item && typeof item === "object" && withCondition?.length) {
            const isPassed = withCondition.every(({ field, equals }) => {
                return item[field] !== undefined && item[field] === equals;
            });
            return isPassed;
        }
        return true;
    }
    _fuse_checkValidateMustBeAnObjectDataType(data) {
        if (!data || typeof data !== "object") {
            throw this._fuse_createGenericError(`Data MUST be valid object`);
        }
    }
    _fuse_checkValidateStrictRequiredFields(onDataObj) {
        this._fuse_checkValidateMustBeAnObjectDataType(onDataObj);
        const { strictRequiredFields } = this._fuse_getLocalVariables();
        if (strictRequiredFields?.length) {
            for (const field of strictRequiredFields) {
                if (onDataObj[field] === null || onDataObj[field] === undefined) {
                    throw this._fuse_createGenericError(`Strict required field NOT defined`);
                }
            }
        }
    }
    _fuse_removeDuplicateString(list) {
        return Array.from(new Set(list));
    }
    _fuse_toMongoProjection(fields) {
        if (fields?.length) {
            const projection = {};
            const uniqueFields = this._fuse_removeDuplicateString(fields);
            uniqueFields.forEach((field) => {
                projection[field] = 1;
            });
            return projection;
        }
        return undefined;
    }
    async _fuse_allHelpValidateGetValue(data) {
        const { error, value } = this._fuse_schema.validate(data, {
            stripUnknown: true,
        });
        if (error) {
            const msg = getJoiValidationErrors(error) ?? "Validation error occured";
            throw this._fuse_errorHelper.fuse_helper_createFriendlyError(msg);
        }
        return await Promise.resolve({ validatedData: value });
    }
    _fuse_createGenericError(error) {
        return new FuseGenericError(error);
    }
    async fuse_getOneById({ dataId, withCondition, }) {
        this._fuse_errorHelper.fuse_helper_validateRequiredString({ dataId });
        const db = await this._fuse_getDbInstance();
        const nativeId = this._fuse_getNativeMongoId(dataId);
        const query = { _id: nativeId };
        const dataInDb = await db.findOne(query, { projection: { _id: 0 } });
        if (!(dataInDb?.id === dataId && dataInDb.featureEntity === this._fuse_featureEntityValue)) {
            return null;
        }
        const passed = this._fuse_withConditionPassed({ item: dataInDb, withCondition });
        if (!passed) {
            return null;
        }
        return dataInDb;
    }
    async fuse_getManyByIds({ dataIds, fields, withCondition, }) {
        const uniqueIds = this._fuse_removeDuplicateString(dataIds);
        const fullUniqueIds = uniqueIds.map((id) => this._fuse_getNativeMongoId(id));
        const db = await this._fuse_getDbInstance();
        if (withCondition?.length && fields?.length) {
            withCondition.forEach((item) => {
                fields.push(item.field);
            });
        }
        const projection = this._fuse_toMongoProjection(fields) ?? { _id: -1 };
        const query = { _id: { $in: fullUniqueIds } };
        const dataListInDb = await db.find(query, { projection: projection }).toArray();
        if (!dataListInDb?.length) {
            return [];
        }
        if (withCondition?.length) {
            const dataFiltered = dataListInDb.filter((item) => {
                const passed = this._fuse_withConditionPassed({ item, withCondition });
                return passed;
            });
            return dataFiltered;
        }
        return dataListInDb;
    }
    async fuse_createOne({ data }) {
        this._fuse_checkValidateStrictRequiredFields(data);
        const { partitionKeyFieldName, featureEntityValue } = this._fuse_getLocalVariables();
        let dataId = data[partitionKeyFieldName];
        if (!dataId) {
            dataId = this._fuse_generateDynamoTableKey();
        }
        if (!(dataId && typeof dataId === "string")) {
            throw this._fuse_createGenericError("Invalid dataId generation");
        }
        const dataMust = this._fuse_getBaseObject({ dataId });
        const fullData = {
            ...data,
            ...dataMust,
            _id: this._fuse_getNativeMongoId(dataId),
        };
        if (fullData.featureEntity !== featureEntityValue) {
            throw this._fuse_createGenericError("FeatureEntity mismatched");
        }
        const validated = await this._fuse_allHelpValidateGetValue(fullData);
        const db = await this._fuse_getDbInstance();
        const result = await db.insertOne(validated.validatedData);
        if (!result?.insertedCount) {
            throw this._fuse_createGenericError(this._fuse_operationNotSuccessful);
        }
        const final = { ...validated.validatedData };
        delete final._id;
        return final;
    }
    async fuse_updateOne({ dataId, updateData, withCondition, }) {
        this._fuse_errorHelper.fuse_helper_validateRequiredString({ dataId });
        const nativeId = this._fuse_getNativeMongoId(dataId);
        const query = { _id: nativeId };
        const db = await this._fuse_getDbInstance();
        const dataInDb = await db.findOne(query);
        if (!(dataInDb?.id === dataId && dataInDb.featureEntity === this._fuse_featureEntityValue)) {
            throw this._fuse_createGenericError("Record does not exists");
        }
        const passed = this._fuse_withConditionPassed({ item: dataInDb, withCondition });
        if (!passed) {
            throw this._fuse_createGenericError("Record with conditions does not exists");
        }
        const dataMust = this._fuse_getBaseObject({ dataId });
        const data = {
            ...dataInDb,
            ...updateData,
            ...dataMust,
        };
        const validated = await this._fuse_allHelpValidateGetValue(data);
        const result = await db.replaceOne(query, validated.validatedData);
        if (!result.modifiedCount) {
            throw this._fuse_createGenericError(this._fuse_operationNotSuccessful);
        }
        const final = { ...validated.validatedData };
        delete final._id;
        return final;
    }
    async fuse_getManyBySecondaryIndex(paramOption) {
        const result = await this._fuse_getManyBySecondaryIndexPaginateBase(paramOption, false);
        if (result?.mainResult) {
            return result.mainResult;
        }
        return [];
    }
    fuse_getManyBySecondaryIndexPaginate(paramOption) {
        return this._fuse_getManyBySecondaryIndexPaginateBase(paramOption, true);
    }
    async _fuse_getManyBySecondaryIndexPaginateBase(paramOption, canPaginate) {
        const { secondaryIndexOptions } = this._fuse_getLocalVariables();
        if (!secondaryIndexOptions?.length) {
            throw this._fuse_createGenericError("Invalid secondary index definitions");
        }
        if (!paramOption?.indexName) {
            throw this._fuse_createGenericError("Invalid index name input");
        }
        const secondaryIndex = secondaryIndexOptions.find((item) => {
            return item.indexName === paramOption.indexName;
        });
        if (!secondaryIndex) {
            throw this._fuse_createGenericError("Secondary index not named/defined");
        }
        const index_PartitionKeyFieldName = secondaryIndex.partitionKeyFieldName;
        const index_SortKeyFieldName = secondaryIndex.sortKeyFieldName;
        const partitionSortKeyQuery = paramOption.sortKeyQuery
            ? {
                ...{ [index_SortKeyFieldName]: paramOption.sortKeyQuery },
                ...{ [index_PartitionKeyFieldName]: paramOption.partitionKeyValue },
            }
            : { [index_PartitionKeyFieldName]: paramOption.partitionKeyValue };
        const localVariables = this._fuse_getLocalVariables();
        const hasFeatureEntity = [
            index_PartitionKeyFieldName,
            index_SortKeyFieldName,
        ].includes(localVariables.sortKeyFieldName);
        paramOption.query = (paramOption.query || {});
        if (!hasFeatureEntity) {
            paramOption.query = {
                ...paramOption.query,
                ...{ [localVariables.sortKeyFieldName]: localVariables.featureEntityValue },
            };
        }
        else if (index_PartitionKeyFieldName !== localVariables.sortKeyFieldName) {
            if (localVariables.sortKeyFieldName === index_SortKeyFieldName) {
                partitionSortKeyQuery[index_SortKeyFieldName] = { $eq: localVariables.featureEntityValue };
            }
        }
        const queryDefs = {
            ...paramOption.query,
            ...partitionSortKeyQuery,
        };
        const queryDefData = this._fuse_filterQueryOperation.processQueryFilter({ queryDefs });
        const db = await this._fuse_getDbInstance();
        const projection = this._fuse_toMongoProjection(paramOption.fields) ?? { _id: 0 };
        const sort01 = [];
        if (paramOption.sort === "desc") {
            sort01.push([index_PartitionKeyFieldName, -1]);
            sort01.push([index_SortKeyFieldName, -1]);
        }
        else {
            sort01.push([index_PartitionKeyFieldName, 1]);
            sort01.push([index_SortKeyFieldName, 1]);
        }
        const cursorFind = db.find(queryDefData);
        if (sort01?.length) {
            cursorFind.sort(sort01);
        }
        if (projection) {
            cursorFind.project(projection);
        }
        let nextPageHash = undefined;
        const pagingOptions = {
            pageNo: 0,
            limit: 50,
        };
        if (canPaginate) {
            if (paramOption.limit && UtilService.isNumberic(paramOption.limit)) {
                pagingOptions.limit = Number(paramOption.limit);
            }
            try {
                const nextPageHash01 = paramOption?.pagingParams?.nextPageHash;
                if (nextPageHash01) {
                    const param01 = JSON.parse(UtilService.decodeStringFromBase64(nextPageHash01));
                    if (param01.limit) {
                        pagingOptions.limit = param01.limit;
                    }
                    if (param01.pageNo) {
                        pagingOptions.pageNo = param01.pageNo;
                    }
                }
            }
            catch (error) {
                LoggingService.log(error?.message);
            }
            cursorFind.limit(pagingOptions.limit);
            const skipValue = pagingOptions.limit * (pagingOptions.pageNo || 0);
            if (skipValue) {
                cursorFind.skip(skipValue);
            }
        }
        else {
            if (paramOption.limit && UtilService.isNumberic(paramOption.limit)) {
                cursorFind.limit(Number(paramOption.limit));
            }
        }
        const results = await cursorFind.hint(paramOption.indexName).toArray();
        if (canPaginate && results.length && results.length >= pagingOptions.limit) {
            pagingOptions.pageNo = pagingOptions.pageNo + 1;
            nextPageHash = UtilService.encodeStringToBase64(JSON.stringify(pagingOptions));
        }
        return {
            mainResult: results,
            nextPageHash: nextPageHash,
        };
    }
    async fuse_deleteById({ dataId, withCondition, }) {
        this._fuse_errorHelper.fuse_helper_validateRequiredString({ dataId });
        const db = await this._fuse_getDbInstance();
        const nativeId = this._fuse_getNativeMongoId(dataId);
        const query = { _id: nativeId };
        const dataInDb = await db.findOne(query);
        if (!(dataInDb?.id === dataId && dataInDb.featureEntity === this._fuse_featureEntityValue)) {
            throw this._fuse_createGenericError("Record does not exists");
        }
        const passed = this._fuse_withConditionPassed({ item: dataInDb, withCondition });
        if (!passed) {
            throw this._fuse_createGenericError("Record with conditions does not exists for deletion");
        }
        const result = await db.deleteOne(query);
        if (!result?.deletedCount) {
            throw this._fuse_createGenericError(this._fuse_operationNotSuccessful);
        }
        return dataInDb;
    }
}
